const LoadingModal = ({ currentModal, loadingModalRef }) => {
  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={loadingModalRef} id="modalLoading" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            {/* <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalLoadingTitle"></h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> */}
            <div className="modal-body">
              <div className="loadingModal-text">Hold tight, we're working on it!</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoadingModal